import { cn } from "@/lib/utils";

/**
 * "The assistant is thinking" — a single pulsing dot, ChatGPT-style.
 *
 * Deliberately NOT a bubble: three dots inside a grey rounded rectangle read as
 * a message that is about to arrive, which sets the wrong expectation on a turn
 * that often resolves into an offer CARD rather than prose. A bare dot reads as
 * a state, not a pending sentence.
 */
export function TypingIndicator({ className }: { className?: string }) {
  return (
    <div
      className={cn("tw:flex tw:items-center tw:py-2 tw:pl-1", className)}
      aria-label="Assistant is thinking"
      role="status"
    >
      <span className="so-thinking-dot tw:block tw:size-2.5 tw:rounded-full tw:bg-[#523D33]" />
    </div>
  );
}
